// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support.
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    AiAgent,
    AiAgentFromJSON,
    AiAgentToJSON,
    AiBaseUrl,
    AiBaseUrlFromJSON,
    AiBaseUrlToJSON,
    AiInferenceOperation,
    AiInferenceOperationFromJSON,
    AiInferenceOperationToJSON,
    AiKeyLimits,
    AiKeyLimitsFromJSON,
    AiKeyLimitsToJSON,
    AiTargetType,
    AiTargetTypeFromJSON,
    AiTargetTypeToJSON,
} from './';

/**
 * Snapshot of policy at issuance. For MODEL, agent is omitted. For AGENT, agent is required, models contains only agent.invocationModel, defaultModel equals it, and operations is exactly [CHAT_COMPLETIONS]. Never contains the raw secret or LiteLLM hash. Subsequent profile edits do not rewrite this snapshot; persistent account limits continue to apply.
 * @export
 * @interface AiKeyMetadata
 */
export interface AiKeyMetadata {
    /**
     * Opaque Enter key ID used for metadata and revocation, distinct from the virtual key or its hash.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof AiKeyMetadata
     */
    id: string;
    /**
     * Granted account to which the issued key and its spend belong.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof AiKeyMetadata
     */
    bankUserId: string;
    /**
     * Stable use-case identifier unique within this account and environment. Values such as basic and advanced are examples, not a closed list, and do not determine the target type.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof AiKeyMetadata
     */
    profileId: string;
    /**
     *
     * OpenAPI data type: {AiTargetType}
     * @type {AiTargetType}
     * @memberof AiKeyMetadata
     */
    targetType: AiTargetType;
    /**
     *
     * OpenAPI data type: {AiAgent}
     * @type {AiAgent}
     * @memberof AiKeyMetadata
     */
    agent?: AiAgent;
    /**
     *
     * OpenAPI data type: {AiBaseUrl}
     * @type {AiBaseUrl}
     * @memberof AiKeyMetadata
     */
    baseUrl: AiBaseUrl;
    /**
     * Issuance time in UTC.
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof AiKeyMetadata
     */
    createdAt: string;
    /**
     * Absolute UTC gateway expiry. Cannot be extended; request a new key after rechecking current account access and policy.
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof AiKeyMetadata
     */
    expiresAt: string;
    /**
     * REVOKED takes precedence over EXPIRED. ACTIVE means not expired/revoked, not that budgets, rate limits, or model availability guarantee inference success.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof AiKeyMetadata
     */
    status: AiKeyMetadataStatusEnum;
    /**
     *
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof AiKeyMetadata
     */
    models: Array<string>;
    /**
     * Server-resolved value for the OpenAI model field. A direct-model alias for MODEL keys, or the exact a2a/<registered-agent-name> value for an AGENT key. Never a wildcard or unrestricted model-access sentinel.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof AiKeyMetadata
     */
    defaultModel: string;
    /**
     *
     * OpenAPI data type: {array}
     * @type {Array<AiInferenceOperation>}
     * @memberof AiKeyMetadata
     */
    operations: Array<AiInferenceOperation>;
    /**
     *
     * OpenAPI data type: {AiKeyLimits}
     * @type {AiKeyLimits}
     * @memberof AiKeyMetadata
     */
    keyLimits: AiKeyLimits;
}

export function AiKeyMetadataFromJSON(json: any): AiKeyMetadata {
    return {
            'id': json['id'],
            'bankUserId': json['bankUserId'],
            'profileId': json['profileId'],
            'targetType': AiTargetTypeFromJSON(json['targetType']),
            'agent': !exists(json, 'agent') ? undefined : AiAgentFromJSON(json['agent']),
            'baseUrl': AiBaseUrlFromJSON(json['baseUrl']),
            'createdAt': json['createdAt'],
            'expiresAt': json['expiresAt'],
            'status': json['status'],
            'models': json['models'],
            'defaultModel': json['defaultModel'],
            'operations': (json['operations'] as Array<any>).map(AiInferenceOperationFromJSON),
            'keyLimits': AiKeyLimitsFromJSON(json['keyLimits']),
    };

}

export function AiKeyMetadataToForm(value?: AiKeyMetadata): any {
    let jsonVal = AiKeyMetadataToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function AiKeyMetadataToJSON(value?: AiKeyMetadata): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'bankUserId': cleanupBlankValuesForBackend(value.bankUserId),
            'profileId': cleanupBlankValuesForBackend(value.profileId),
            'targetType': AiTargetTypeToJSON(value.targetType),
            'agent': AiAgentToJSON(value.agent),
            'baseUrl': AiBaseUrlToJSON(value.baseUrl),
            'createdAt': cleanupBlankValuesForBackend(value.createdAt),
            'expiresAt': cleanupBlankValuesForBackend(value.expiresAt),
            'status': cleanupBlankValuesForBackend(value.status),
            'models': cleanupBlankValuesForBackend(value.models),
            'defaultModel': cleanupBlankValuesForBackend(value.defaultModel),
            'operations': (value.operations as Array<any>).map(AiInferenceOperationToJSON),
            'keyLimits': AiKeyLimitsToJSON(value.keyLimits),
    };
}

/**
* @export
* @enum {string}
*/
export enum AiKeyMetadataStatusEnum {
    ACTIVE = 'ACTIVE',
    EXPIRED = 'EXPIRED',
    REVOKED = 'REVOKED'
}
